// Typed client for the Studio Connected agents API (/v1/studio/mcp/*).
// See app/api/studio_mcp_router.py: the signed-in person's own MCP
// connections (OAuth grants on aura-mcp), and revoking one.

import { apiRequest } from "./http";

export interface ConnectedAgent {
  grantId: string;
  // The client's CIMD URL (or registered id in dev).
  clientId: string;
  clientName: string | null;
  scopes: string[];
  createdAt: string;
  lastUsedAt: string | null;
}

export const listConnectedAgents = () => apiRequest<ConnectedAgent[]>("/studio/mcp/grants");

// Ends every token of the grant: the client can't refresh, and aura-mcp
// refuses its access tokens within a minute.
export const revokeConnectedAgent = (grantId: string) =>
  apiRequest<void>(`/studio/mcp/grants/${encodeURIComponent(grantId)}`, { method: "DELETE" });
